import { dismissConfirmDialog } from 'actions/dialog'
import { t, useLocale } from 'acs-translate'
import { useDispatch, useSelector } from 'react-redux'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import CheckIcon from '@material-ui/icons/Check'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import React from 'react'
import cx from 'classnames'
import useStyles from 'isomorphic-style-loader/useStyles'

import s from './SuccessDialog.scss'

const dialogSelector = state => state.dialog

const SuccessDialog = () => {
  useLocale()
  useStyles(s)
  const dispatch = useDispatch()
  const dialog = useSelector(dialogSelector)
  const {
    isOpen,
    title,
    message,
    contentStyle = {},
    footnote,
    footnoteStyle = {},
    onConfirm,
    onCancel,
    titleColor,
    confirmLabel = 'txtYyBoConfirm',
    cancelLabel = 'txtYyBoCancel',
    type,
    isShowCancel = true,
    canCancel = true,
  } = dialog

  const handleClose = () => {
    if (!canCancel) return
    dispatch(dismissConfirmDialog())
    if (onCancel) onCancel()
  }

  const handleConfirm = () => {
    dispatch(dismissConfirmDialog())
    if (onConfirm) onConfirm()
  }

  return (
    <Dialog open={isOpen && type === 'success'} onClose={handleClose}>
      <Box mt={2} display="flex" justifyContent="center" alignItems="center">
        <CheckIcon className={s.icon} />
      </Box>
      {!!title && (
        <Box display="flex" justifyContent="center" alignItems="center">
          <div className={cx(s.title, { [s.normal]: titleColor === 'normal' })}>
            {t(title, { fallback: title })}
          </div>
        </Box>
      )}
      {!!message && (
        <DialogContent className={s.content}>
          <DialogContentText id="alert-dialog-description" style={contentStyle}>
            {t(message, { fallback: message })}
          </DialogContentText>
        </DialogContent>
      )}
      {!!footnote && (
        <DialogContent className={s.content}>
          <DialogContentText style={footnoteStyle}>
            {t(footnote, { fallback: footnote })}
          </DialogContentText>
        </DialogContent>
      )}
      {isOpen && (
        <div className={s.actions}>
          {isShowCancel && (
            <Button
              className={s.button}
              onClick={handleClose}
              color="primary"
              variant="outlined"
              disableElevation>
              {t(cancelLabel, { fallback: cancelLabel })}
            </Button>
          )}
          <Button
            className={s.button}
            onClick={handleConfirm}
            color="primary"
            variant="contained"
            disableElevation
            autoFocus>
            {t(confirmLabel, { fallback: confirmLabel })}
          </Button>
        </div>
      )}
    </Dialog>
  )
}

export default SuccessDialog
